import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ReportTemplatesDashboardQueryKeys } from "modules/ReportTemplatesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerID, ReportTemplateID } from "models";

type AssignReportTemplatePayload = {
  id: ReportTemplateID;
  dealer_id: DealerID | null;
};

export const useAssignReportTemplateMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: AssignReportTemplatePayload) => (await ApiInstance.post("/report_templates/assign", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const cachedReportTemplates = typedQueryClient.getQueryData(ReportTemplatesDashboardQueryKeys.list);
      if (!cachedReportTemplates) return;

      const templateIdx = cachedReportTemplates.findIndex(reportTemplate => reportTemplate.id === payload.id);
      if (templateIdx === -1) return;

      typedQueryClient.setQueryData(
        ReportTemplatesDashboardQueryKeys.list,
        cachedReportTemplates.with(templateIdx, { ...cachedReportTemplates[templateIdx], dealer_id: payload.dealer_id })
      );
    }
  });
